export const presetAudios = [
  {
    id: "f2_arpeggios_belt_e",
    name: "f2_arpeggios_belt_e - from test dataset",
    path: "/demo_presets/audio/f2_arpeggios_belt_e.wav",
    voiceType: "soprano",
    audioFeaturesPath:
      "/demo_presets/precalc_features/f2_arpeggios_belt_e.json",
  },
  {
    id: "f8_arpeggios_breathy_u",
    name: "f8_arpeggios_breathy_u - from test dataset",
    path: "/demo_presets/audio/f8_arpeggios_breathy_u.wav",
    voiceType: "soprano",
    audioFeaturesPath:
      "/demo_presets/precalc_features/f8_arpeggios_breathy_u.json",
  },
  {
    id: "f8_scales_straight_o",
    name: "f8_scales_straight_o - from test dataset",
    path: "/demo_presets/audio/f8_scales_straight_o.wav",
    voiceType: "soprano",
    audioFeaturesPath: "/demo_presets/precalc_features/f8_scales_straight_o.json",
  },
  {
    id: "f2_scales_vibrato_a",
    name: "f2_scales_vibrato_a - from test dataset",
    path: "/demo_presets/audio/f2_scales_vibrato_a.wav",
    voiceType: "soprano",
    audioFeaturesPath:
      "/demo_presets/precalc_features/f2_scales_vibrato_a.json",
  },
  {
    id: "m3_scales_belt_o",
    name: "m3_scales_belt_o - from test dataset",
    path: "/demo_presets/audio/m3_scales_belt_o.wav",
    voiceType: "tenor",
    audioFeaturesPath: "/demo_presets/precalc_features/m3_scales_belt_o.json",
  },
  {
    id: "m10_scales_breathy_u",
    name: "m10_scales_breathy_u - from test dataset",
    path: "/demo_presets/audio/m10_scales_breathy_u.wav",
    voiceType: "bass",
    audioFeaturesPath:
      "/demo_presets/precalc_features/m10_scales_breathy_u.json",
  },
  {
    id: "m10_arpeggios_vibrato_a",
    name: "m10_arpeggios_vibrato_a - from test dataset",
    path: "/demo_presets/audio/m10_arpeggios_vibrato_a.wav",
    voiceType: "bass",
    audioFeaturesPath:
      "/demo_presets/precalc_features/m10_arpeggios_vibrato_a.json",
  },

  {
    id: "m3_long_straight_u",
    name: "m3_long_straight_u - from test dataset",
    path: "/demo_presets/audio/m3_long_straight_u.wav",
    voiceType: "bass",
    audioFeaturesPath: "/demo_presets/precalc_features/m3_long_straight_u.json",
  },
  // {
  //   id: "champions_1",
  //   name: "Champions (version 1 - mezzo 1) - target belt-breathy",
  //   path: "/demo_presets/audio/champions_1.wav",
  //   voiceType: "mezzo",
  //   audioFeaturesPath: "/demo_presets/precalc_features/champions_1.json",
  //   phrase:
  //     "We are the champions, my friend. And we'll keep on fighting till the end.",
  //   highlightedText: [
  //     { phrase: "the champions," },
  //     { phrase: "and we'll" },
  //     { phrase: "till the end." },
  //   ],
  //   highlightClass: "bg-purple-400 text-blueblack",
  //   defaultClass: "bg-electricblue text-blueblack",
  //   highlightLabel: "breathy",
  //   defaultLabel: "belt",
  //   highlightLabelColor: "text-purple-400",
  //   defaultLabelColor: "text-electricblue",
  // },
  // {
  //   id: "champions_2",
  //   name: "Champions (version 2 - mezzo 1) - no target",
  //   path: "/demo_presets/audio/champions_2.wav",
  //   voiceType: "mezzo",
  //   audioFeaturesPath: "/demo_presets/precalc_features/champions_2.json",
  // },
  {
    id: "hello_1",
    name: "Hello (version 1 - mezzo 1) - target belt-breathy",
    path: "/demo_presets/audio/hello_1.wav",
    voiceType: "mezzo",
    audioFeaturesPath: "/demo_presets/precalc_features/hello_1.json",
    phrase:
      "Hello... it's me. I was wondering if after all these years you'd like to meet.",
    highlightedText: [
      { phrase: "Hello..." },
      { phrase: "I was" },
      { phrase: "if after all these" },
      { phrase: "meet." },
    ],
    highlightClass: "bg-purple-400 text-blueblack",
    defaultClass: "bg-electricblue text-blueblack",
    highlightLabel: "breathy",
    defaultLabel: "belt",
    highlightLabelColor: "text-purple-400",
    defaultLabelColor: "text-electricblue",
  },
  {
    id: "hello_2",
    name: "Hello (version 2 - mezzo 1) - no target",
    path: "/demo_presets/audio/hello_2.wav",
    voiceType: "mezzo",
    audioFeaturesPath: "/demo_presets/precalc_features/hello_2.json",
  },
  // {
  //   id: "let_it_be_1",
  //   name: "Let it be (version 1 - mezzo 1) - target vibrato-straight",
  //   path: "/demo_presets/audio/let_it_be_1.wav",
  //   voiceType: "mezzo",
  //   audioFeaturesPath: "/demo_presets/precalc_features/let_it_be_1.json",
  //   phrase: "Let it be, let it be, let it be, let it be.",
  //   highlightedText: [
  //     { phrase: "let it be,", occurrences: [2] },
  //     { phrase: "let it be." },
  //   ],
  //   highlightClass: "bg-darkpink text-blueblack",
  //   defaultClass: "bg-warmyellow text-blueblack",
  //   highlightLabel: "vibrato",
  //   defaultLabel: "straight",
  //   highlightLabelColor: "text-darkpink",
  //   defaultLabelColor: "text-warmyellow",
  // },
  // {
  //   id: "let_it_be_2",
  //   name: "Let it be (version 2 - mezzo 1) - no target",
  //   path: "/demo_presets/audio/let_it_be_2.wav",
  //   voiceType: "mezzo",
  //   audioFeaturesPath: "/demo_presets/precalc_features/let_it_be_2.json",
  // },
  {
    id: "love_you_1",
    name: "I will always love you (version 1 - mezzo 1 - target vibrato-straight",
    path: "/demo_presets/audio/love_you_1.wav",
    voiceType: "mezzo",
    audioFeaturesPath: "/demo_presets/precalc_features/love_you_1.json",
    phrase: "And I-I will always love you.",
    highlightedText: [{ phrase: "-I" }, { phrase: "ways love" }],
    highlightClass: "bg-darkpink text-blueblack",
    defaultClass: "bg-warmyellow text-blueblack",
    highlightLabel: "vibrato",
    defaultLabel: "straight",
    highlightLabelColor: "text-darkpink",
    defaultLabelColor: "text-warmyellow",
  },
  {
    id: "love_you_2",
    name: "I will always love you (version 2 - mezzo 1) - no target",
    path: "/demo_presets/audio/love_you_2.wav",
    voiceType: "mezzo",
    audioFeaturesPath: "/demo_presets/precalc_features/love_you_2.json",
  },
];
